import { render, staticRenderFns } from "./SurveyInfo.vue?vue&type=template&id=5cd67e90&scoped=true"
import script from "./SurveyInfo.vue?vue&type=script&lang=js"
export * from "./SurveyInfo.vue?vue&type=script&lang=js"
import style0 from "./SurveyInfo.vue?vue&type=style&index=0&id=5cd67e90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd67e90",
  null
  
)

export default component.exports